// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("webshop.webshop.shopping_cart");
var shopping_cart = webshop.webshop.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
	// Don't open /cart while a background cart save is still running
	// (PIT-TASK-2027-000346).
	shopping_cart.hold_navigation_until_saved();
});

// Shared cart-save lock — serializes ALL cart saves (qty, delivery mode,
// delivery date) through a single queue so that only one Quotation save is
// in flight at a time.  Prevents "Document has been modified after you have
// opened it" (TimestampMismatchError) when the user changes controls faster
// than the server can save.
//
// Exposed on the global shopping_cart object so that the page-specific
// cart.js (templates/pages/cart.js), which is loaded as a separate script
// outside the web bundle, can route delivery-mode/date saves through the
// same queue.
let cart_save_in_progress = false
let pending_cart_save = null

shopping_cart.queue_cart_save = function queue_cart_save(opts) {
	// Only the most recent change matters — replace any pending save.
	pending_cart_save = opts

	if (cart_save_in_progress) return

	process_cart_save()
}

function process_cart_save() {

	if (!pending_cart_save) {
		cart_save_in_progress = false
		return
	}

	const next = pending_cart_save
	pending_cart_save = null
	cart_save_in_progress = true

	// No freeze overlay — background cart saves (qty, delivery mode,
	// delivery date) are silent.  The cart content (items, totals, cart
	// count badge) updates itself when the AJAX response arrives, which
	// is the only feedback the user sees.  Place Order / Request
	// Quotation are deliberate actions and freeze explicitly.
	return frappe.call({
		type: "POST",
		method: next.method,
		args: next.args,
		btn: next.btn,
		callback: function(r) {
			// Skip the callback if a newer save is already queued — only the
			// last response should update the UI.
			if(next.callback && !pending_cart_save)
				next.callback(r);
		},
		error: function() {
			// On network/HTTP failure: clear the lock so the user can retry.
			// No freeze to remove (background saves don't freeze).
			// Frappe server-side exceptions (TimestampMismatch, validation,
			// …) arrive as 200 + r.exc and go through callback, not here.
			cart_save_in_progress = false
			pending_cart_save = null
		},
		always: function () {
			if (pending_cart_save) {
				process_cart_save()
			} else {
				cart_save_in_progress = false
				shopping_cart.set_cart_count(true);
			}
		}
	});

}

// Wait for the cart-save queue to fully drain (no save in progress and no
// pending save queued).  Used by place_order / request_quotation so they
// don't submit while a background save is still in flight — which would
// race on the Quotation document and trigger TimestampMismatchError.
shopping_cart.drain_queue = function drain_queue() {
	return new Promise(function(resolve) {
		function check() {
			if (!cart_save_in_progress && !pending_cart_save) {
				resolve();
				return;
			}
			setTimeout(check, 50);
		}
		check();
	});
};

// Is a cart save (still) running in the background?
shopping_cart.cart_save_in_flight = function cart_save_in_flight() {
	return cart_save_in_progress || !!pending_cart_save;
};

// Opening /cart while a background save is still running renders the cart
// WITHOUT the item that was just added — the page is delivered faster than the
// save finishes, and the customer has to reload to see the item
// (PIT-TASK-2027-000346).  Background saves are silent by design, so we hold
// the navigation back until the running save has landed instead of showing an
// incomplete cart.  Without a running save the click is not touched at all.
shopping_cart.hold_navigation_until_saved = function hold_navigation_until_saved() {
	$(document).on('click', 'a[href="/cart"], a[href^="/cart?"], a[href^="/cart#"]', function (e) {
		if (!shopping_cart.cart_save_in_flight()) {
			return;
		}
		e.preventDefault();
		const target = this.href;
		shopping_cart.drain_queue().then(function () {
			window.location.href = target;
		});
	});
};

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").on('shown.bs.dropdown', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'webshop.webshop.shopping_cart.cart.get_shopping_cart_menu',
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function(opts) {

		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {

			shopping_cart.queue_cart_save({
				method: "webshop.webshop.shopping_cart.cart.update_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
					additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
					with_items: opts.with_items || 0
				},
				btn: opts.btn,
				callback: opts.callback,
			})

		}

	},

	// PIT-TASK-2027-000368 ADJUSTMENT 1 — single owner of the cart-icon
	// visibility, driven by the "Always Show Cart Icon" toggle (Webshop
	// Settings -> Shopping Cart tab).
	//
	// The setting is rendered into the markup by
	// templates/includes/navbar/navbar_icons.html as the
	// `data-always-show-cart-icon` attribute on <li class="cart-icon"> — the
	// single source of truth, so no extra AJAX call is needed to read the
	// mode. The rules:
	//
	//   mode 1 -> icon visible, no matter whether the cart is empty
	//   mode 0 -> icon visible only while the cart holds at least one item
	//             (default; the template already renders it `hidden`)
	//
	// "Enable Shopping Cart" (enabled = 0) overrides BOTH modes and stays the
	// single responsibility of show_cart_navbar()/is_cart_enabled(). The icon
	// is toggled by the CSS class `hidden` only (never an inline style, see
	// set_cart_count) and #cart-count is never touched here.
	always_show_cart_icon: null,
	cart_enabled: true,
	cart_item_count: 0,

	set_cart_icon_visibility: function() {
		var $cart = $(".cart-icon");
		if (!$cart.length) {
			return;
		}

		if (shopping_cart.always_show_cart_icon === null) {
			// Attribute missing (e.g. a page cache entry rendered before this
			// change): fall back to the setting's default (0 — icon only with
			// items in the cart).
			var mode = $cart.first().attr("data-always-show-cart-icon");
			shopping_cart.always_show_cart_icon = parseInt(mode, 10) === 1 ? 1 : 0;
		}

		var has_items = parseInt(shopping_cart.cart_item_count, 10) > 0;
		var visible = shopping_cart.cart_enabled !== false
			&& (shopping_cart.always_show_cart_icon === 1 || has_items);

		$cart.toggleClass("hidden", !visible);
	},

	set_cart_count: function(animate=false) {
		$(".intermediate-empty-cart").remove();

		// PIT-TASK-2027-000368: never hide the icon with an inline style (an
		// inline display:none could not be undone by show_cart_navbar()'s
		// class toggle — that is exactly what made the icon disappear) and
		// NEVER remove the #cart-count node (the counters are updated by id,
		// so removing the node broke every later update).
		//
		// PIT-TASK-2027-000368 ADJUSTMENT 1: the icon itself is hidden/shown
		// through the CSS class `hidden` only, and who owns that decision is
		// the "Always Show Cart Icon" setting — see
		// set_cart_icon_visibility(). Hiding a DISABLED cart stays the single
		// responsibility of show_cart_navbar() below.
		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");

		var render_cart_count = function(cart_count) {
			var count = parseInt(cart_count, 10);
			if (isNaN(count) || count < 0) {
				count = 0;
			}

			if (count > 0) {
				$badge.text(count).removeClass("hidden").show();

				if (animate) {
					$cart.addClass("cart-animate");
					setTimeout(() => {
						$cart.removeClass("cart-animate");
					}, 500);
				}
			} else {
				// Empty cart: the badge goes away — the node itself stays in
				// the DOM (visibility via CSS class). In mode 0 the icon is
				// hidden along with it by set_cart_icon_visibility().
				$badge.text("").addClass("hidden").hide();
			}

			// The count decides the icon in mode 0 (and must not override a
			// disabled cart in mode 1), so publish it before re-evaluating
			// the icon visibility.
			shopping_cart.cart_item_count = count;
			shopping_cart.set_cart_icon_visibility();

			if (count === 0) {
				$(".cart-tax-items").hide();
				$(".btn-place-order").hide();
				$(".cart-payment-addresses").hide();

				let intermediate_empty_cart_msg = `
					<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
						${ __("Cart is Empty") }
					</div>
				`;
				$(".cart-table").after(intermediate_empty_cart_msg);
			}
		};

		var cart_count = frappe.get_cookie("cart_count");
		var parsed_cookie = parseInt(cart_count, 10);
		var has_cookie_count = cart_count !== undefined && cart_count !== null
			&& cart_count !== "" && !isNaN(parsed_cookie);

		// The cookie is written on login and on every cart mutation only, and it
		// is a SESSION cookie while `sid` persists — a logged-in user who
		// restarted the browser (or a session that never logged in) has NO
		// usable cookie even with a full cart. A cookie value of 0 is treated as
		// "unverified" as well: a silent 0 is exactly the failure the user
		// reported, so it is double-checked against the server instead of being
		// trusted blindly. Only a positive cookie value is used directly (the
		// fast path — no extra request on a normal page view).
		if (frappe.session.user === "Guest" || !has_cookie_count || parsed_cookie === 0) {
			frappe.call({
				method: "webshop.webshop.shopping_cart.cart.get_cart_count",
				callback: function(r) {
					render_cart_count(r && r.message);
				},
				error: function() {
					render_cart_count(has_cookie_count ? parsed_cookie : 0);
				},
			});
		} else {
			render_cart_count(parsed_cookie);
		}
	},

	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes}) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			with_items: 1,
			btn: this,
			callback: function(r) {
				if(!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count();

					if (r.message.delivery_mode !== undefined) {
						var $wrapper = $("#delivery-mode-wrapper");
						if ($wrapper.length) {
							var html = $.trim(r.message.delivery_mode);
							if (html) {
								$wrapper.show().html(html);
								// Re-bind the date input change handler in the new HTML
								if (shopping_cart.bind_desired_delivery_date) {
									shopping_cart.bind_desired_delivery_date();
								}
							} else {
								$wrapper.hide();
							}
						}
					}

					// The cart body was re-rendered.  If the comment textarea was
					// replaced, a typed-but-unsaved comment is gone — drop any
					// pending comment flush so submit doesn't persist a phantom
					// value (see bind_cart_comment in templates/pages/cart.js).
					if (shopping_cart.reset_cart_comment_pending) {
						shopping_cart.reset_cart_comment_pending();
					}

					// PIT-TASK-2027-000368: the header cart icon is NOT hidden
					// when the cart is edited from the cart page — it has to
					// stay visible (and reachable) on every webshop page.
				}
			},
		});
	},

	show_cart_navbar: function () {
		frappe.call({
			method: "webshop.webshop.doctype.webshop_settings.webshop_settings.is_cart_enabled",
			callback: function(r) {
				// PIT-TASK-2027-000368 ADJUSTMENT 1: a disabled cart hides the
				// icon in BOTH "Always Show Cart Icon" modes. The decision
				// stays here; the mode + item count are applied together in
				// set_cart_icon_visibility() so the last answer always wins.
				shopping_cart.cart_enabled = !!r.message;
				shopping_cart.set_cart_icon_visibility();
			}
		});
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);

			// Sold Out toggle (PIT-TASK-2027-000358): the listing renders
			// the button with a disabled look (it is a <div>, so the
			// browser does not block the click) — the handler must not
			// add the item; the server rejects it as well.
			if ($btn.hasClass('ws-sold-out-btn') || $btn.data('sold-out')) {
				return;
			}

			if (frappe.session.user==="Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			// Find qty input: look in the shared .cart-action-row parent, or fall back to card parent
			const $action_row = $btn.closest('.cart-action-row');
			let $item_qty = $action_row.length
				? $action_row.find(".item-qty")
				: $btn.parent().find(".item-qty-area .item-qty");

			// Default to the item's min buying qty if no input found or value is empty/zero
			const addMinQty = parseInt($item_qty.data("min-qty")) || 1;
			let item_qty = parseInt($item_qty.val()) || addMinQty;
			if (item_qty < addMinQty) item_qty = addMinQty;

			const item_code = $btn.data('item-code');

			// Read qty from current view's action row
			// PIT-TASK-2027-000200: the in-cart count is now a badge INSIDE the
			// add-to-cart button (.ws-cart-count-badge), not a separate text hint.
			const $badge_local = $action_row.length
				? $action_row.find('.ws-cart-count-badge')
				: $btn.closest('.card, .list-row').find('.ws-cart-count-badge');
			const current_qty = parseInt($badge_local.text(), 10) || 0;
			const new_qty = current_qty + item_qty;

			// Create badge if it doesn't exist yet (first add-to-cart for this item;
			// badge is only server-rendered when item.in_cart was already true)
			if (new_qty > 0 && !$(`.ws-cart-count-badge[data-item-code="${item_code}"]`).length) {
				$(`.btn-add-to-cart-list[data-item-code="${item_code}"]`).each(function() {
					// Skip if this button already has one
					if (!$(this).find('.ws-cart-count-badge').length) {
						$(this).append(`<span class="ws-cart-count-badge" data-item-code="${item_code}">${new_qty}</span>`);
					}
				});
			}
			// Update ALL badges for this item across grid, list, and single views
			$(`.ws-cart-count-badge[data-item-code="${item_code}"]`).each(function() {
				const $b = $(this);
				$b.text(new_qty);
				$b.removeClass('hidden');
			});

			webshop.webshop.shopping_cart.update_cart({
				item_code,
				qty: new_qty
			});

			// Reset qty input back to the item's min buying qty (not 1);
			// items with min_qty=1 stay 1. PIT-TASK-2027-000205.
			$item_qty.val($item_qty.data("min-qty") || 1);
		});
	},

});